var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['col', `gap${_vm.gap}`, {
    'f-align-center': _vm.center, 
    'f-centered': _vm.centered, 
    'flex-between': _vm.between,
    'w-100': _vm.full,
    'flex-wrap': _vm.wrap,
  }],style:({width: _vm.width})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }